import { Component, OnInit, inject, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import {
  CompetitionsService,
  ContestantHistoryEntry,
} from '../../../core/competitions/competitions';
import { PickList } from '../pick-list/pick-list';

/** A contestant's basic info plus every competition the current owner runs
 *  that they're/were part of, each with their picks there (F-004 Slice 8).
 *  Mounted/unmounted by the parent (via @if) — fetches on init, same
 *  pattern as EntriesModal. */
@Component({
  selector: 'app-contestant-modal',
  imports: [PickList],
  templateUrl: './contestant-modal.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contestant-modal.css',
})
export class ContestantModal implements OnInit {
  private readonly competitions = inject(CompetitionsService);

  readonly competitionId = input.required<number>();
  readonly userId = input.required<number>();
  readonly displayName = input('');
  readonly email = input('');
  readonly closed = output<void>();

  readonly loading = signal(true);
  readonly errorMessage = signal<string | null>(null);
  readonly history = signal<ContestantHistoryEntry[]>([]);

  async ngOnInit(): Promise<void> {
    this.loading.set(true);
    this.errorMessage.set(null);
    try {
      this.history.set(
        await this.competitions.getContestantHistory(
          this.competitionId(),
          this.userId(),
        ),
      );
    } catch {
      this.errorMessage.set(
        "Could not load this contestant's history — try again.",
      );
    } finally {
      this.loading.set(false);
    }
  }

  close(): void {
    this.closed.emit();
  }
}
